import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, SingleAnswerStepData } from '@packages/shared/core/quiz/entities';

type SingleAnswerQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const SingleAnswerQuizStep = ({ id, renderQuizScreen }: SingleAnswerQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, updateUserPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as SingleAnswerStepData;

  const goBack = async () => back();

  const onChosen = async (text?: string, key?: string) => {
    updateUserPreferences(dataKey, text?.toLowerCase());
    await next(text, key);
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onBack: goBack,
        totalSteps,
        stepOrder,
        ...(stepData as SingleAnswerStepData),
      })}
    </>
  );
};

export default SingleAnswerQuizStep;
